module.exports = __webpack_public_path__ + "static/media/facebook.bfa47fd4.svg";